export default __webpack_public_path__ + "img/EjHJqtea.d3344d6f.svg";